// this secret var is gone from React 16. this is very hubspot specific
window['ReactDOM'] = React.__SECRET_DOM_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;


if (typeof window !== "undefined" && window.hubspot && window.hubspot.define) {
  hubspot.define("react-dom", [], function() { return window["ReactDOM"]; });
  hubspot.define("ReactDOM", [], function() { return window["ReactDOM"]; });
}




//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/conversations-visitor/node_modules/bender-webpack/lib/legacy-modules/module-manifest-dependency-loader.js!/usr/share/hubspot/build/.hubspot/static-archive/react-dom/static-7.6/react-dom.js?legacy-module
// module id = 1217
// module chunks = 